// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"351":"75db0ab0","491":"f09c7d68","535":"195cdcce"}[chunkId] + ".css";
};